import { Point } from '../utils/point';
import { AngleTypeEnum } from '../../../../../enum/workbench/angle-type-enum';

export class ConfigurationCutaway {
  id?: string;
  origin: Point;
  angleType: AngleTypeEnum;

  constructor(point: Point, angleType: AngleTypeEnum) {
    this.origin = point;
    this.angleType = angleType;
  }
}
